export const filtersData = [
    {
        title: "Sport",
        types: [
            "Cricket",
            "Basketball",
            "Football",
            "Boxing",
            "Hockey",
            "Athletics",
        ],
    },
    {
        title: "Category",
        types: [
            "Equipment",
            "Apparel",
            "Shoes",
            "Jerseys",
            "Accessories",
            "Trophies & medals",
        ],
    },
];

export const ratingFilter = [
    { numOfStars: 4, name: "rating", _id: "rating4plus" },
    { numOfStars: 3, name: "rating", _id: "rating3plus" },
    { numOfStars: 2, name: "rating", _id: "rating2plus" },
    { numOfStars: 1, name: "rating", _id: "rating1plus" },
];

export const sortData = [
    "Best selling",
    "Price: Low to high",
    "Price: High to low",
    "Newest arrivals",
];
